import { useEffect, useState } from 'react';

import { useDataFetch } from 'src/hooks/useDataFetch';

import { PageSearchResults } from '../../../types/components';

const TYPE_AHEAD_LIMIT = 5;

/**
 * A custom hook for the global search typeahead. It uses the same API as usePageSearch, but has predifined `skip` and `limit` values,
 * while only accepts one search value, rather than fields from a form.
 *
 * @param {string} searchValue
 * The term to search for
 */
export const usePageSearchTypeahead = (searchValue: string) => {
  // const [searchTerm, setSearchTerm] = useState('')
  const [searchKey, setSearchKey] = useState<string | null>(null);
  const { data, isLoading, error } = useDataFetch<PageSearchResults>(searchKey);

  useEffect(() => {
    const searchParams = new URLSearchParams();
    searchParams.set('term', searchValue);
    searchParams.set('skip', '0');
    searchParams.set('limit', TYPE_AHEAD_LIMIT.toString());

    const querystring = searchParams.toString();
    setSearchKey(`/api/search?${querystring}`);
  }, [searchValue]);

  return {
    searchKey: searchKey || '',
    data,
    isLoading,
    error,
    searchValue,
  };
};
